// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ListFilledIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13 22H3a1 1 0 010-2h10a1 1 0 010 2z"/><rect x="2" y="2" width="20" height="16" rx="2"/></svg>'} />;

ListFilledIcon.displayName = 'ListFilledIcon';

export default ListFilledIcon;
